

// import React, { useEffect, useState } from "react";
// import Header from "../Components/Header";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { BsWhatsapp, BsTelegram } from "react-icons/bs";
// import { FaCopy, FaShareAlt, FaUserFriends, FaCoins } from "react-icons/fa";
// import CopyToClipboard from "react-copy-to-clipboard";
// import moment from "moment";

// const Refer = () => {
//   const [user, setUser] = useState();
//   const [referData, setReferData] = useState([]);
//   const [cardData, setGame] = useState([]);

//   // --- Data Fetching Logic (Preserved) ---
//   useEffect(() => {
//     Cashheader();
//   }, []);

//   const Cashheader = () => {
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     axios
//       .get(`https://api.rrludo.in/me`, { headers })
//       .then((res) => {
//         setUser(res.data);
//         Allgames(res.data.referral_code);
//       })
//       .catch(() => { });
//   };

//   const Allgames = async (id) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await axios
//       .get(`https://api.rrludo.in/referral/code/${id}`, { headers })
//       .then((res) => {
//         setReferData(res.data);
//       });
//   };

//   const ReferHistory = async (id) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await axios
//       .get(`https://api.rrludo.in/referral/code/winn/${id}`, { headers })
//       .then((res) => {
//         setGame(res.data);
//       });
//   };

//   useEffect(() => {
//     ReferHistory();
//   }, []);

//   if (user === undefined) return null;

//   // --- Referral Text (Preserved) ---
//   const referralText = `RR-LUDO लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते है। 
// दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 3% कमीशन दिया जाएगा. 
// 100% भरोसेमंद प्लेटफार्म। 24 hours support https://rrludo.in/login?refer=${user.referral_code}.`;

//   // ✅ Toast Alert for Dream11 Theme
//   const Toast = Swal.mixin({
//     toast: true,
//     position: 'top-end',
//     showConfirmButton: false,
//     timer: 1500,
//     background: '#1e1e1e',
//     color: '#fff'
//   });

//   const handleCopy = () => Toast.fire({ icon: "success", title: "Code Copied!" });
//   const handleLinkCopy = () => Toast.fire({ icon: "success", title: "Link Copied!" });

//   // --- UI STYLES (DREAM11 DARK THEME) ---
//   const styles = {
//     pageWrapper: {
//       background: 'radial-gradient(circle at top, #1a1a1a, #0a0a0a)',
//       minHeight: "100vh",
//       paddingTop: '90px',
//       color: '#fff',
//       fontFamily: "'Inter', sans-serif"
//     },
//     statCard: {
//       background: 'rgba(30, 30, 30, 0.6)',
//       backdropFilter: 'blur(10px)',
//       borderRadius: '24px',
//       padding: '25px',
//       border: '1px solid rgba(255, 255, 255, 0.05)',
//       textAlign: 'center',
//       height: '100%'
//     },
//     referBox: {
//       background: '#161616',
//       borderRadius: '24px',
//       padding: '30px 20px',
//       border: '1px solid #222',
//       marginTop: '25px'
//     },
//     codeInput: {
//       background: '#000',
//       border: '1px dashed #444',
//       borderRadius: '12px',
//       color: '#fff',
//       fontSize: '20px',
//       fontWeight: '800',
//       textAlign: 'center',
//       padding: '12px',
//       width: '100%',
//       letterSpacing: '2px'
//     },
//     copyBtn: {
//       background: 'linear-gradient(180deg, #FF3131 0%, #BA0000 100%)',
//       color: '#fff',
//       border: 'none',
//       borderRadius: '12px',
//       padding: '12px 25px',
//       fontWeight: '700',
//       marginTop: '15px',
//       width: '100%',
//       textTransform: 'uppercase'
//     },
//     shareCircle: (color) => ({
//       width: '50px',
//       height: '50px',
//       borderRadius: '50%',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: '22px',
//       color: '#fff',
//       background: color,
//       cursor: 'pointer',
//       boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
//       transition: '0.2s'
//     }),
//     howItWorks: {
//         background: 'rgba(255, 49, 49, 0.05)',
//         borderRadius: '20px',
//         padding: '20px',
//         borderLeft: '4px solid #FF3131',
//         marginTop: '30px'
//     }
//   };

//   return (
//     <>
//       <Header user={user} />
//       <div style={styles.pageWrapper}>
//         <div className="container py-4">
          
//           {/* Header Section */}
//           <div className="text-center mb-5">
//             <h2 className="fw-bold mb-1">Refer & Earn</h2>
//             <p style={{color: '#888'}}>Invite friends and earn lifetime commission</p>
//           </div>

//           {/* Stat Cards Grid */}
//           <div className="row g-3 mb-4">
//             <div className="col-6">
//               <div style={styles.statCard}>
//                 <div style={{background: 'rgba(255,49,49,0.1)', width: '40px', height: '40px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px'}}>
//                     <FaUserFriends color="#FF3131" />
//                 </div>
//                 <p style={{color: '#666', fontSize: '12px', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600'}}>Total Refers</p>
//                 <h3 className="fw-bold mb-0">{referData || 0}</h3>
//               </div>
//             </div>
//             <div className="col-6">
//               <div style={styles.statCard}>
//                 <div style={{background: 'rgba(255,215,0,0.1)', width: '40px', height: '40px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px'}}>
//                     <FaCoins color="#FFD700" />
//                 </div>
//                 <p style={{color: '#666', fontSize: '12px', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600'}}>Total Earnings</p>
//                 <h3 className="fw-bold mb-0">₹{user?.referral_earning || 0}</h3>
//               </div>
//             </div>
//           </div>

//           {/* Referral Code Section */}
//           <div style={styles.referBox}>
//             <div className="text-center mb-4">
//                 <p className="small text-muted mb-2">YOUR UNIQUE REFERRAL CODE</p>
//                 <div style={styles.codeInput}>{user?.referral_code}</div>
//                 <CopyToClipboard text={user?.referral_code} onCopy={handleCopy}>
//                     <button style={styles.copyBtn}>
//                         <FaCopy className="me-2" /> Copy Code
//                     </button>
//                 </CopyToClipboard>
//             </div>

//             <div className="d-flex align-items-center mb-4">
//                 <div style={{flex: 1, height: '1px', background: '#333'}}></div>
//                 <div className="px-3 small text-muted">OR SHARE VIA</div>
//                 <div style={{flex: 1, height: '1px', background: '#333'}}></div>
//             </div>

//             {/* Social Share Icons */}
//             <div className="d-flex justify-content-around gap-4">
//               <a href={`whatsapp://send?text=${referralText}`} target="_blank" rel="noopener noreferrer" style={styles.shareCircle('#25D366')}>
//                 <BsWhatsapp />
//               </a>
//               <a href={`https://t.me/share/url?url=https://rrludo.in/login?refer=${user?.referral_code}&text=${encodeURIComponent(referralText)}`} target="_blank" rel="noopener noreferrer" style={styles.shareCircle('#0088cc')}>
//                 <BsTelegram />
//               </a>
//               <CopyToClipboard text={referralText} onCopy={handleLinkCopy}>
//                 <div style={styles.shareCircle('#444')}>
//                   <FaShareAlt />
//                 </div>
//               </CopyToClipboard>
//             </div>
//           </div>

//           {/* How It Works Section */}
//           <div style={styles.howItWorks}>
//             <h6 className="fw-bold text-white mb-3">How it works?</h6>
//             <div className="d-flex gap-3 mb-3">
//                 <div style={{minWidth: '24px', height: '24px', borderRadius: '50%', background: '#FF3131', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold'}}>1</div>
//                 <p className="small mb-0" style={{color: '#aaa'}}>Share your referral link or code with your friends via social media.</p>
//             </div>
//             <div className="d-flex gap-3">
//                 <div style={{minWidth: '24px', height: '24px', borderRadius: '50%', background: '#FF3131', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold'}}>2</div>
//                 <p className="small mb-0" style={{color: '#aaa'}}>Get <b>3% Lifetime Commission</b> instantly whenever they play a game.</p>
//             </div>
//           </div>

//           <div className="text-center mt-5" style={{opacity: '0.3', fontSize: '11px', letterSpacing: '1px'}}>
//               SECURE REFERRAL SYSTEM V2.0
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Refer;

import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import axios from "axios";
import Swal from "sweetalert2";
import { BsWhatsapp, BsTelegram } from "react-icons/bs";
import { FaCopy, FaShareAlt, FaUserFriends, FaCoins, FaGift, FaArrowRight } from "react-icons/fa";
import CopyToClipboard from "react-copy-to-clipboard";
import moment from "moment";

const Refer = () => {
  const [user, setUser] = useState();
  const [referData, setReferData] = useState([]);
  const [cardData, setGame] = useState([]);

  // --- Data Fetching Logic (Preserved) ---
  useEffect(() => {
    Cashheader();
  }, []);

  const Cashheader = () => {
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    axios
      .get(`https://api.rrludo.in/me`, { headers })
      .then((res) => {
        setUser(res.data);
        Allgames(res.data.referral_code);
      })
      .catch(() => { });
  };

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await axios
      .get(`https://api.rrludo.in/referral/code/${id}`, { headers })
      .then((res) => {
        setReferData(res.data);
      });
  };

  const ReferHistory = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await axios
      .get(`https://api.rrludo.in/referral/code/winn/${id}`, { headers })
      .then((res) => {
        setGame(res.data);
      });
  };

  useEffect(() => {
    ReferHistory();
  }, []);

  if (user === undefined) return null;

  // --- Referral Text (Preserved) ---
  const referralText = `RR-LUDO लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते है। 
दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 3% कमीशन दिया जाएगा. 
100% भरोसेमंद प्लेटफार्म। 24 hours support https://rrludo.in/login?refer=${user.referral_code}.`;

  // ✅ Theme Aligned Toast
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    background: '#000',
    color: '#FF9800'
  });

  const handleCopy = () => Toast.fire({ icon: "success", title: "Code Copied!" });
  const handleLinkCopy = () => Toast.fire({ icon: "success", title: "Link Copied!" });

  // --- NEW LIGHT THEME STYLES ---
  const styles = {
    pageWrapper: {
      background: '#FFFDE7', // Light Yellow
      minHeight: "100vh",
      paddingTop: '10px',
      fontFamily: "'Poppins', sans-serif"
    },
    heroCard: {
      background: '#000',
      borderRadius: '0 0 40px 40px',
      padding: '40px 20px',
      textAlign: 'center',
      color: '#fff',
      marginTop: '-20px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
    },
    rewardBadge: {
      background: 'linear-gradient(90deg, #FF9800 0%, #FB8C00 100%)',
      color: '#000',
      padding: '8px 20px',
      borderRadius: '50px',
      fontSize: '12px',
      fontWeight: '800',
      display: 'inline-block',
      marginBottom: '15px'
    },
    statRow: {
      display: 'flex',
      gap: '15px',
      marginTop: '-30px',
      padding: '0 20px'
    },
    statBox: {
      flex: 1,
      background: '#fff',
      borderRadius: '20px',
      padding: '20px 10px',
      textAlign: 'center',
      boxShadow: '0 10px 20px rgba(0,0,0,0.05)',
      border: '1px solid #FFF9C4'
    },
    shareSection: {
      background: '#fff',
      margin: '25px 20px',
      borderRadius: '24px',
      padding: '25px',
      border: '2px dashed #FF9800'
    },
    codeDisplay: {
      fontSize: '28px',
      fontWeight: '900',
      letterSpacing: '4px',
      color: '#000',
      margin: '15px 0'
    },
    btnMain: {
      background: '#000',
      color: '#FF9800',
      border: 'none',
      borderRadius: '14px',
      padding: '16px',
      width: '100%',
      fontWeight: '700',
      fontSize: '14px',
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px'
    },
    stepCard: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      padding: '15px',
      background: 'rgba(255, 152, 0, 0.1)',
      borderRadius: '16px',
      marginBottom: '10px'
    },
    circleIcon: (bg) => ({
      width: '40px',
      height: '40px',
      borderRadius: '12px',
      background: bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#000',
      fontSize: '18px'
    })
  };

  return (
    <>
      <Header user={user} />
      <div style={styles.pageWrapper}>
        
        {/* Hero Header */}
        <div style={styles.heroCard}>
          <div style={styles.rewardBadge}>
            <FaGift style={{marginRight: '8px'}}/> UNLIMITED REWARDS
          </div>
          <h2 style={{fontWeight: '800', fontSize: '28px'}}>Refer & Earn Cash</h2>
          <p style={{color: '#aaa', fontSize: '14px'}}>Invite your friends to play and get paid!</p>
        </div>

        {/* Stats Section */}
        <div style={styles.statRow}>
          <div style={styles.statBox}>
            <FaUserFriends color="#FF9800" size={24} />
            <h3 style={{margin: '5px 0 0 0', fontWeight: '800'}}>{referData || 0}</h3>
            <span style={{fontSize: '11px', color: '#999', fontWeight: '600'}}>TOTAL FRIENDS</span>
          </div>
          <div style={styles.statBox}>
            <FaCoins color="#FF9800" size={24} />
            <h3 style={{margin: '5px 0 0 0', fontWeight: '800'}}>₹{user?.referral_earning || 0}</h3>
            <span style={{fontSize: '11px', color: '#999', fontWeight: '600'}}>TOTAL EARNED</span>
          </div>
        </div>

        {/* Share Card */}
        <div style={styles.shareSection}>
          <div style={{textAlign: 'center'}}>
            <span style={{fontSize: '11px', fontWeight: '700', color: '#999', letterSpacing: '1px'}}>YOUR PERSONAL CODE</span>
            <div style={styles.codeDisplay}>{user?.referral_code}</div>
            
            <CopyToClipboard text={user?.referral_code} onCopy={handleCopy}>
               <button style={styles.btnMain}>
                  <FaCopy /> COPY REFERRAL CODE
               </button>
            </CopyToClipboard>
          </div>

          <div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '25px'}}>
              <a href={`whatsapp://send?text=${referralText}`} style={styles.circleIcon('#25D366')}><BsWhatsapp /></a>
              <a href={`https://t.me/share/url?url=https://rrludo.in/login?refer=${user?.referral_code}&text=${encodeURIComponent(referralText)}`} style={styles.circleIcon('#0088cc')}><BsTelegram /></a>
              <CopyToClipboard text={referralText} onCopy={handleLinkCopy}>
                <div style={styles.circleIcon('#FF9800')}><FaShareAlt /></div>
              </CopyToClipboard>
          </div>
        </div>

        {/* Instructions */}
        <div style={{padding: '0 20px 40px 20px'}}>
            <h6 style={{fontWeight: '800', marginBottom: '20px', paddingLeft: '5px'}}>How it works?</h6>
            
            <div style={styles.stepCard}>
                <div style={{fontWeight: '900', color: '#FF9800', fontSize: '24px'}}>01</div>
                <div style={{fontSize: '13px', fontWeight: '600', color: '#333'}}>Share your link with your gaming circle.</div>
                <FaArrowRight style={{marginLeft: 'auto', color: '#FF9800', opacity: 0.5}} />
            </div>

            <div style={styles.stepCard}>
                <div style={{fontWeight: '900', color: '#FF9800', fontSize: '24px'}}>02</div>
                <div style={{fontSize: '13px', fontWeight: '600', color: '#333'}}>Friends join & play games on our platform.</div>
                <FaArrowRight style={{marginLeft: 'auto', color: '#FF9800', opacity: 0.5}} />
            </div>

            <div style={styles.stepCard}>
                <div style={{fontWeight: '900', color: '#FF9800', fontSize: '24px'}}>03</div>
                <div style={{fontSize: '13px', fontWeight: '600', color: '#000'}}>Enjoy <b>3% Lifetime Commission</b> instantly!</div>
            </div>
        </div>

        <div style={{textAlign: 'center', paddingBottom: '30px', color: '#bbb', fontSize: '10px', letterSpacing: '2px', fontWeight: '700'}}>
            BROTHERS LUDO • REFERRAL HUB
        </div>
      </div>
    </>
  );
};

export default Refer;